export class HistoricoDireccionesDto {
  fechaAsignacion: Date;
  usuarioAsigna: string;
  nombreServidor: string;
  nombreUrl: string;
  indicadorHabilitado: boolean;
  estado: string;
  indicadorReactivar: boolean;
  tipoAsignacion: string;
  idAsignacion: number;
  codigoAmbiente: string;
  direccionIp: string;
  compania: string;
  ciudad: string;
  sede: string;
  servicio: string;
  plataforma: string;
  rol: string;
  observaciones: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/historico-direcciones-dto.ts